module.exports = __webpack_public_path__ + "img/map-marker.9e39092a.png";